/*
 * @Descripttion: AI 模型配置接口（分页/详情/新增/修改/启停/删除）
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2026-10-29 10:00:00
 */
import { API_PREFIX } from '../../services/constant'
import { Request } from '../../services/request'

/** 分页查询，可不传参；后端默认按 model_use, id 排序 */
export interface AIModelPageParams {
  current?: number
  size?: number
  ascs?: string
  descs?: string
}

export function AIModelPage(params?: AIModelPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/page`,
    method: 'GET',
    params,
  }
}

/** 详情，用于编辑回显 */
export interface AIModelDetailParams {
  id: number
}

export function AIModelDetail(params: AIModelDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/detail`,
    method: 'GET',
    params,
  }
}

export interface AIModelParams {
  id?: any
  basePlat?: any
  auth?: any
  modelVersion?: any
  modelUrl?: any
  temperature?: any
  maxTokens?: any
  topP?: any
  presencePenalty?: any
  frequencyPenalty?: any
  modelUse?: any
  isEnable?: any
}

/** 新增，后端统一置 isEnable=0 */
export function AIModelSave(body: AIModelParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/save`,
    method: 'POST',
    body,
  }
}

/** 修改，id 必传 */
export function AIModelUpdate(body: AIModelParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/update`,
    method: 'POST',
    body,
  }
}

/** 启用 / 停用，同一 modelUse 只允许一个启用 */
export interface AIModelEnableParams {
  id: number
  isEnable: number
}

export function AIModelEnable(params: AIModelEnableParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/enable`,
    method: 'POST',
    params,
  }
}

/** 删除（逻辑删除），已启用的模型不允许删除 */
export interface AIModelDeleteParams {
  id: number
}

export function AIModelDelete(params: AIModelDeleteParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/sysaimodel/delete`,
    method: 'POST',
    params,
  }
}
